import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";
import { adminAuth } from "../../services/adminApi";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminAuth.login(email, password);
      toast.success("Bienvenida 🍯");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg =
        err.response?.data?.detail || "Error al iniciar sesión";
      toast.error(typeof msg === "string" ? msg : "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-stone-50 to-amber-100/40 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-700 rounded-2xl mb-4 shadow-lg shadow-amber-200">
            <span className="text-white text-2xl font-bold">B</span>
          </div>
          <h1 className="text-3xl font-bold text-stone-800">
            Panel de administración
          </h1>
          <p className="text-stone-500 mt-1 text-sm">
            Burbujas de mami · Acceso privado
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-amber-100 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-stone-700">
                Correo
              </Label>
              <div className="relative mt-1.5">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
                <Input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  className="pl-10 h-11"
                  data-testid="admin-login-email"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="text-stone-700">
                Contraseña
              </Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="pl-10 pr-10 h-11"
                  data-testid="admin-login-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-600"
                >
                  {showPassword ? (
                    <EyeOff className="w-4 h-4" />
                  ) : (
                    <Eye className="w-4 h-4" />
                  )}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-amber-700 hover:bg-amber-800 text-white rounded-xl font-medium shadow-md hover:shadow-lg transition-all"
              data-testid="admin-login-submit"
            >
              {loading ? "Iniciando..." : "Entrar"}
            </Button>
          </form>
        </div>

        <p className="text-center text-xs text-stone-400 mt-6">
          🔒 Acceso restringido · Solo para administradoras
        </p>
      </div>
    </div>
  );
}
